document.addEventListener("DOMContentLoaded",function() {
    const hiddenBenefitTableRows = document.querySelectorAll(".hidden-benefit-table-row");
    let benefitTableRows;
    const targetNode = document.querySelector("div[data-lion-tier-benefits-compare]");
    if(targetNode) {
        const displayOtherTextInBenefitTable = () => {
            let rowTitle;
            console.clear();
            if(hiddenBenefitTableRows && benefitTableRows) {
                for (const hiddenBenefitTableRow of hiddenBenefitTableRows) {
                    rowTitle = hiddenBenefitTableRow.children[0].innerText;
                    for (const benefitTableRow of benefitTableRows) {
                        if(benefitTableRow.children[0].innerText === rowTitle) {
                            benefitTableRow.children[1].children[0].innerText = hiddenBenefitTableRow.children[1].innerText;
                            benefitTableRow.children[2].children[0].innerText = hiddenBenefitTableRow.children[2].innerText;
                            benefitTableRow.children[3].children[0].innerText = hiddenBenefitTableRow.children[3].innerText;
                        }
                    }
                }
            }
        }
        const observer = new MutationObserver(function(mutationsList, observer) {
            for(let mutation of mutationsList) {
                if (mutation.type === 'childList') {
                    benefitTableRows = mutation.target?.querySelectorAll(".lion-tier-benefits-compare__row");
                    displayOtherTextInBenefitTable();
                }
            }
        });
        const config = { childList: true };
        observer.observe(targetNode, config);
    }
});